import { render, staticRenderFns } from "./ProductBottomBadges.vue?vue&type=template&id=b5d4b1da&scoped=true&"
import script from "./ProductBottomBadges.vue?vue&type=script&lang=js&"
export * from "./ProductBottomBadges.vue?vue&type=script&lang=js&"
import style0 from "./ProductBottomBadges.vue?vue&type=style&index=0&id=b5d4b1da&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d4b1da",
  null
  
)

export default component.exports